import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { PlatformAdminUtilityControllerService } from '../services/Platform/services';

@Injectable({
    providedIn: 'root'
})
export class CanAuthenticationGuard extends KeycloakAuthGuard implements CanActivate {
    public permissionList;
    constructor(protected router: Router, protected keycloakAngular: KeycloakService,
        protected platformAdminUtilityControllerService: PlatformAdminUtilityControllerService) {
        super(router, keycloakAngular);
    }

    isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise((resolve, reject) => {
            if (!this.authenticated) {
                this.keycloakAngular.login()
                    .catch(e => console.error(e));
                return reject(false);
            }

            const permission = route.data.permission;
            this.platformAdminUtilityControllerService.getUserAccountDetails().subscribe(resp => {
                this.permissionList = resp['permissions'];
                if (resp.roles.includes('agent')) {
                    this.router.navigate(['/agent-chat']);
                    return resolve(false);
                }
                else if (resp.roles.includes('superAgent')) {
                    this.router.navigate(['/whatsapp/agent-analytics']);
                    return resolve(false);
                }
                else if (this.permissionList.indexOf(permission) > -1) {
                    route.data.data['permissionList'] = this.permissionList;
                    resolve(true);
                    const element: HTMLElement = document.getElementsByClassName('burger-line')[0] as HTMLElement;
                    if (element.classList.contains('burgerTop')) {
                        element.click();
                    }
                } else {
                    this.router.navigate(['/']);
                    resolve(false);
                }
            });
        });
    }
}
